import { Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageTitle from "src/components/Displays/PageTitle";
import PageSubTitle from "src/components/Displays/PageSubTitle";
import { SMART_CHARGING_PATHS } from "src/consts/Routes/SmartCharging";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import VerticalLinearProgress, {
  progressMenuSx,
  stepProgressProps,
} from "src/components/ProgressBar/VerticalLinearProgressBar";

const STEPS = ["Overview", "Verbundene Geräte"] as const;

export const pathCalculator = (pathname: string) => {
  switch (pathname) {
    case SMART_CHARGING_ROUTES.OVERVIEW_START:
      return 0;
    case SMART_CHARGING_ROUTES.OVERVIEW_DETAILS:
      return 55;
    default:
      return 20;
  }
};

const activeStep = (pathname: string) =>
  pathname === SMART_CHARGING_ROUTES.OVERVIEW_DETAILS ? 2 : 1;

const SmartChargingOverviewProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack gap="13px" sx={progressMenuSx}>
      <PageTitle text={"Menü"} />
      {SMART_CHARGING_PATHS.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 55,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress
            variant="determinate"
            value={55 - pathCalculator(pathname)}
            {...stepProgressProps(STEPS, activeStep(pathname))}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {STEPS.map((text) => (
              <PageSubTitle key={text} text={text} />
            ))}
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SmartChargingOverviewProgressBar;
